const DARK_LUMINANCE_THRESHOLD = 0.5;

function relativeLuminance(color: string): number | null {
    const hex = color.trim().replace('#', '');
    const sixDigit = hex.length === 3 ? [...hex].map((c) => c + c).join('') : hex;
    if (!/^[0-9a-f]{6}$/i.test(sixDigit)) return null;

    const linearChannel = (offset: number) => {
        const channel = Number.parseInt(sixDigit.slice(offset, offset + 2), 16) / 255;
        return channel <= 0.03928 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4;
    };
    return 0.2126 * linearChannel(0) + 0.7152 * linearChannel(2) + 0.0722 * linearChannel(4);
}

/** Colours we cannot parse are treated as light, since the card defaults to a light background. */
export function isDark(color: string): boolean {
    const luminance = relativeLuminance(color);
    return luminance !== null && luminance < DARK_LUMINANCE_THRESHOLD;
}
